import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <img
              src="/img/logos/logos.svg"
              className="footer-img mx-auto d-block img-fluid"
              alt="UNC Extensión — Apoyo a la Gestión Local"
            />
          </div>
        </div>
      </div>

      <div className="footer-disclaimer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/*Espacios duros para que no se parta el nombre del programa
                 ni la sigla al pasar a dos líneas en el celular.*/}
              <small>
                Desarrollado por el Programa Raíz de Apoyo a la
                Gesti&oacute;n&nbsp;Local - UNC&nbsp;-&nbsp;SEU
              </small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
